import { useEffect } from 'react';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

/**
 * This is the redirect page for MS authentication. It shoudl be outside of the main paths that are wrapped
 * in the MsalAuthenticationTemplate (AuthWrapper.tsx) to avoid it trying to use the redirect data or doing another login.
 *
 * In theory, user should not see this page. It should only be accessed in an iframe.
 * @returns
 */
export const RedirectHandler = () => {
  useEffect(() => {
    broadcastResponseToMainFrame().catch((err) => {
      console.error('Error sending auth response to main frame ', err);
    });
  }, []);
  return null;
};
